import * as React from "react";
import { connect } from "react-redux";
import { ApplicationState, ConnectedReduxProps } from "@reducers/index";
import { Job } from "@models/job";
import { deleteRequest, fetchRequest } from "@actions/job";
import JobsTable from "@components/jobs/Table";
import { Button, Card, Col, Input, Row, Modal } from "antd";
import TableRenderer from "@hocs/TableRenderer";
import JobForm from "@components/jobs/Form";
import { FormattedMessage } from "react-intl";
import { getJobsList } from "@reducers/job";
import SearchJobsComponent from "@components/jobs/Search";
import { NavLink } from "react-router-dom";

interface PropsFromState {
  loading: boolean;
  data: Job[];
  errors?: string;
  count: number;
}

interface PropsFromDispatch {
  fetchRequest: typeof fetchRequest;
  deleteRequest: typeof deleteRequest;
}

// Combine both state + dispatch props - as well as any props we want to pass - in a union type.
type AllProps = PropsFromState & PropsFromDispatch & ConnectedReduxProps;

class JobsIndexPage extends React.Component<AllProps> {
  deleteJob = (item: Job): any => {
    this.props.deleteRequest({
      params: {
        id: item.id
      }
    });
  };

  render() {
    const { loading, data, search, currentPage } = this.props;
    return (
      <div>
        <div className={`toggle-button-wrapper`}>
          <NavLink to={`/jobs/create`}>
            <Button type={"primary"}>
              <FormattedMessage
                id="app.new_job"
                defaultMessage={`Create Job`}
              />
            </Button>
          </NavLink>
        </div>
        <div className={"page-table-wrapper"}>
          <Card className={`page-table-header`} bordered={false}>
            <SearchJobsComponent search={search} />
          </Card>

          <JobsTable
            data={data}
            currentPage={currentPage}
            rowKey={record => record.id}
            deleteFn={this.deleteJob}
            loading={loading}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ jobs }: ApplicationState) => ({
  loading: jobs.loading,
  data: getJobsList(jobs),
  count: jobs.count
});

const mapDispatchToProps = {
  fetchRequest,
  deleteRequest
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TableRenderer(JobsIndexPage));
